// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2LDKV","description":"PatientConsentPreview_description__3UQDG"};